var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { TextField } from '@material-ui/core';
import styled from 'react-emotion';
export var Wrapper = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  width: 500px;\n  gap: 15px;\n  flex-direction: column;\n"], ["\n  display: flex;\n  width: 500px;\n  gap: 15px;\n  flex-direction: column;\n"])));
export var ButtonWrapper = styled('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  gap: 15px;\n"], ["\n  display: flex;\n  gap: 15px;\n"])));
export var GridWrapper = styled('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  max-height: 400px;\n"], ["\n  display: flex;\n  width: 100%;\n  max-height: 400px;\n"])));
export var CustomTextField = styled(TextField)({
    '&&': {
        '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
            transform: "translate(0px, -15px) scale(0.75)"
        }
    }
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Groups.Styles.js.map